// Application Configuration
// Centralized configuration for the RE Platform

export const config = {
  // API Configuration
  api: {
    baseUrl: import.meta.env.VITE_API_BASE_URL || "http://localhost:3001/api",
    timeout: 10000, // 10 seconds
    retries: 3,
  },

  // External APIs
  companiesHouse: {
    baseUrl: "https://api.company-information.service.gov.uk",
    apiKey: import.meta.env.VITE_COMPANIES_HOUSE_API_KEY,
  },

  landworth: {
    baseUrl: import.meta.env.VITE_LANDWORTH_API_URL,
    apiKey: import.meta.env.VITE_LANDWORTH_API_KEY,
  },

  // Application Settings
  app: {
    name: "RE Platform v4 MVP",
    version: "1.0.0",
    environment: import.meta.env.MODE || "development",
  },

  // Feature Flags
  features: {
    enableFieldEnrichment:
      import.meta.env.VITE_ENABLE_FIELD_ENRICHMENT === "true",
    enableAdvancedSearch:
      import.meta.env.VITE_ENABLE_ADVANCED_SEARCH === "true",
    enableOfflineMode: import.meta.env.VITE_ENABLE_OFFLINE_MODE === "true",
    enableMetadataCache: import.meta.env.VITE_ENABLE_METADATA_CACHE !== "false",
  },

  // UI Configuration
  ui: {
    itemsPerPage: 20,
    searchDebounceMs: 300,
    notificationTimeout: 5000, // 5 seconds
  },

  // Validation Rules
  validation: {
    maxFileSize: 10 * 1024 * 1024, // 10MB
    allowedFileTypes: ["pdf", "doc", "docx", "xls", "xlsx", "jpg", "png"],
    passwordMinLength: 8,
  },
};

export default config;
